<template>
  <v-dialog
      fullscreen
      eager
      v-model="dialog"
      hide-overlay
      content-class="form-dialog"
  >
    <v-card elevation="0">
      <v-col class="text-right px-4">
        <v-btn icon @click="dialog = false" ><v-icon large color="primary">close</v-icon></v-btn>
      </v-col>

      <v-container>
        <h3 class="primary--text text-center font-weight-bold pt-3">
          {{ $t('legal:imprint.title')}}
        </h3>
        <v-card
          elevation="0"
          flat
          tile
        >
          <v-card-text>
            <v-row justify="center">
              <v-col cols="12" md="6">
                <p class="text-h6 text-center">
                  <b>VIEW Promotion GmbH</b><br>
                  Frauscherberg 8<br>
                  A-5211 Friedburg<br>
                </p>
                <p class="text-h6 text-center">
                  <b>{{ $t('legal:imprint.ceo') }}:</b> Johannes Schober<br>
                </p>
                <p class="text-h6 text-center">
                  <b>Tel.:</b> +43 7746 28520<br>
                  <b>Mail:</b> office@view-elevator.at<br>
                  <b>UID:</b> ATU69234214<br>
                  <b>FNB:</b> 426968w<br>
                </p>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>

export default {
  name: "ImprintComponent",
  data() {
    return {
      dialog: false
    }
  }
 }
</script>